module.exports = __webpack_public_path__ + "static/media/ic_general_borders_black.6eb43b08.svg";